import client from "./axiosConfig";

export const login = (values) => {
  const config = {
    url: "/auth/login/",
    method: "POST",
    data: values,
  };
  const response = client(config);
  return response;
};

export const PasswordResetRequest = (data)=>{
  const config = {
    url: "/users/password-reset-request/",
    method: "POST",
    data
  }
  return client(config);
}


export const verifyToken = (userEncodedId, token, data)=>{
  const config = {
    url: `/users/reset-password/verify/${userEncodedId}/${token}/`,
    method: "GET",
    data
  }
  return client(config);
}

export const ResetPassword = (userEncodedId, token, data)=>{
  const config = {
    url: `/users/reset-password/${userEncodedId}/${token}/`,
    method: "POST",
    data
  }
  return client(config);
}
